import React from "react";
import PropTypes from "prop-types";
import ThemedSelect from "components/FormControls/ThemedSelect";
const fields = [
  ["gstRegistered", "Registered for GST"],
  ["isLargeBusiness", "Large business"],
  ["isGovernmentEntity", "Government entity"],
];
export default function RctiEligibility({
  values,
  onChange,
  disabled = false,
}) {
  return (
    <fieldset className="rcti-eligibility">
      <legend>RCTI eligibility settings</legend>
      {fields.map(([key, label]) => (
        <label key={key}>
          {label}
          <ThemedSelect
            className="rcti-eligibility-select"
            aria-label={label}
            disabled={disabled}
            value={typeof values[key] === "boolean" ? String(values[key]) : ""}
            onChange={(event) =>
              onChange(
                key,
                event.target.value === "" ? null : event.target.value === "true"
              )
            }
          >
            <option value="">Not confirmed</option>
            <option value="true">Yes</option>
            <option value="false">No</option>
          </ThemedSelect>
        </label>
      ))}
    </fieldset>
  );
}
RctiEligibility.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
